var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6532 2.17891C12.0683 1.85321 11.3931 1.6665 10.6697 1.6665H9.25061C6.79692 1.6665 4.89846 3.81704 5.20281 6.25178L5.26894 6.78083C5.39072 7.75509 5.03484 8.72825 4.31327 9.39411C3.32767 10.3036 3.05384 11.7512 3.63914 12.9578L3.72527 13.1354C4.27841 14.2757 5.43443 14.9998 6.70185 14.9998H13.5525C14.6386 14.9998 15.6494 14.445 16.2326 13.5287C17.0557 12.2353 16.8377 10.5386 15.7143 9.49528L15.6777 9.46131C15.3332 9.14137 15.0677 8.75541 14.892 8.33317C14.8203 8.16074 14.7635 7.98225 14.7225 7.79974M7.65329 17.4998L7.90329 17.8332C9.02829 19.3332 11.2783 19.3332 12.4033 17.8332L12.6533 17.4998",
    stroke: "#8F8F8F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9876 4.99967C15.9876 5.92015 15.2414 6.66634 14.321 6.66634C13.4005 6.66634 12.6543 5.92015 12.6543 4.99967C12.6543 4.0792 13.4005 3.33301 14.321 3.33301C15.2414 3.33301 15.9876 4.0792 15.9876 4.99967Z",
    fill: "#CB2F2E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconGrey);
export default __webpack_public_path__ + "static/media/notificationIconGrey.be77129db71911b6e94a0b4afb6a8657.svg";
export { ForwardRef as ReactComponent };